/// <reference path="../notes/NoteLineCell.ts" />


class DeliveryOrderLineCell extends NoteLineCell
{
    private orderProductLabel:MUILabel = null;
    private orderMeasureFormatLabel:MUILabel = null;
    private orderQuantityLabel:MUILabel = null;
    
    awakeFromHTML(){
        super.awakeFromHTML();

        this.orderProductLabel = MUIOutlet(this, "order-product-lbl", "MUILabel");
        this.orderMeasureFormatLabel = MUIOutlet(this, "order-measure-lbl", "MUILabel");
        this.orderQuantityLabel = MUIOutlet(this, "order-quantity-lbl", "MUILabel");
    }
    
    setLine(item:DeliveryOrderLine){
        super.setLine(item);                
        
        //TODO: check when is measures without input format. product.inputFormatDescription
        if (this.inputFormatDropdown) this.inputFormatDropdown.title = item.selectedProduct?.inputFormatDescription(this.inputType, this.inputFormat);;
        if (this.productLabel) this.productLabel.text = item.productName;

        if (this.orderProductLabel) this.orderProductLabel.text = item.orderProductName;
        if (this.orderMeasureFormatLabel) this.orderMeasureFormatLabel.text = item.orderMeasureFormat;        
        if (this.orderQuantityLabel) this.orderQuantityLabel.text = this.nf.stringFromNumber(item.quantity);

        if (item.productError != null) MUICoreLayerAddStyle(this.orderProductLabel.layer, "alert");
        if (item.measureFormatError != null) {
            MUICoreLayerAddStyle(this.orderMeasureFormatLabel.layer, "alert");
            MUICoreLayerAddStyle(this.orderQuantityLabel.layer, "alert");
        }
    }

    productDidSelect(controller:SelectEntityViewController, product:Product, supplierProduct:SupplierProduct){
        super.productDidSelect(controller, product, supplierProduct);

        this.productQuantityLabel.text = this.productQuantityString();
    }
    enterDidPress(){
        if (this.stockNoteLine != null) return;        
        if (this.quantity == 0 || this.quantity == null) return;
                
        let line = DBHelper.createDeliveryOrderLine(this.product, this.tax, this.inputFormat, this.inputType, this.quantity, this.productQuantity, this.priceAmount, this.productNetPriceAmount, this.totalAmount, this.discountFormat, this.discountAmount, this.warehouse, this.stockNote) as DeliveryOrderLine;
        
        if (this.productMeasureType == MeasureUnitType.Container){
            line.orderMeasureFormat = this.nf.stringFromNumber(this.productQuantity) + " (" + this.nf.stringFromNumber(this.productQuantity * this.productContainerQuantity) + " " + MeasureUnits.toString(this.productContainerMeasureType) + ")";
        }
        else {
            line.orderMeasureFormat = this.nf.stringFromNumber(this.productQuantity) + " " + MeasureUnits.toString(this.productMeasureType) ;
        }

        if (line != null) {
            DBHelper.saveMainContext();
            this.reset();
        }
    }
    
    reset(){
        super.reset();
        
        // this.orderedQuantityLabel.text = null;
    }
}